export const WORLD_WIDTH = 360;
export const BLOCK_SIZE = 52;
export const PLAYFIELD_INSET = 22;
export const TOUCH_DRAG_GAIN = 1.2;

export function tierValue(tier: number): bigint {
  return 1n << BigInt(tier);
}

export function formatTier(tier: number): string {
  const value = tierValue(tier);
  if (value < 1_000_000n) return value.toString();
  const units = [
    { value: 1_000_000_000_000_000_000n, suffix: 'E' },
    { value: 1_000_000_000_000_000n, suffix: 'P' },
    { value: 1_000_000_000_000n, suffix: 'T' },
    { value: 1_000_000_000n, suffix: 'B' },
    { value: 1_000_000n, suffix: 'M' },
  ];
  const unit = units.find((candidate) => value >= candidate.value)!;
  const whole = value / unit.value;
  const decimal = (value % unit.value) * 10n / unit.value;
  return `${whole}${decimal > 0n ? `.${decimal}` : ''}${unit.suffix}`;
}

export function chooseSpawnTier(_highestTier: number, random: number): number {
  const entries: Array<[number, number]> = [
    [1, 0.30],
    [2, 0.24],
    [3, 0.18],
    [4, 0.12],
    [5, 0.08],
    [6, 0.05],
    [7, 0.03],
  ];
  let cursor = 0;
  for (const [tier, weight] of entries) {
    cursor += weight;
    if (random < cursor) return tier;
  }
  return entries[entries.length - 1][0];
}

export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}

export function applyRelativeTouchDrag(
  previewWorldX: number,
  deltaClientX: number,
  pixelsPerWorldUnit: number,
): number {
  const min = PLAYFIELD_INSET + BLOCK_SIZE / 2;
  const max = WORLD_WIDTH - PLAYFIELD_INSET - BLOCK_SIZE / 2;
  return clamp(
    previewWorldX + (deltaClientX / pixelsPerWorldUnit) * TOUCH_DRAG_GAIN,
    min,
    max,
  );
}
